<template>
    <div>
        <txt v-model="model.name" label="name"></txt>
        <mailer :id="model.public_id" :useMail="false" v-model="model.mailer"></mailer>
        <div class="section buttons">
            <button @click.prevent="store" class="btn btn-success btn-sm pull-right"><i class="icon icon-save"></i> Save</button>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            name: { default: '' },
        },
        components: {
            'mailer': require('../../mail/mailer.vue').default,
        },
        data() {
            return {
                model: {
                    name: '',
                    public_id : '',
                    company_id : '',
                    mailer: {
                        name: ''
                    }
                }
            }
        },
        created() {
            this.$eventHub.$on('emailtemplateSubmit', this.store);
            this.$eventHub.$on('setEmailtemplate', this.setEmailtemplate);
        },
        methods: {
            store(){
                this.model.mailer.name = this.model.name;
                this.$store('/api/email-templates/store', this);
            },
            setEmailtemplate(data) {
                let vm = this;
                $.each(this.model, function (key, value) {
                    let val = '';
                    if (typeof data[key] !== 'undefined') {
                        val = data[key];
                    }
                    vm.model[key] = val;
                });
            },
        },
        // It's good to clean up event listeners before a component is destroyed.
        beforeDestroy () {
            this.$eventHub.$off('emailtemplateSubmit', this.store);
            this.$eventHub.$off('setEmailtemplate', this.setEmailtemplate);
        }
    }
</script>